module.exports = __webpack_public_path__ + "static/5-d06782a8f7f58f8405b1f660d5d5c6e3.jpg";